// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z7NK_","largestCol":"styles_largestCol__3kRyP","smallestCol":"styles_smallestCol__1gjTg"};